// This is the webpack entry point
// Refrain from putting actual code in here and just import the modules you need;
// import './map'

import './thirdparty';
import './nav/nav';
import './carousel/carousel';
import './feed/feed';
import './hero/hero';
// import './slider/slider';
